(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const bar = document.querySelector('sticky-add-to-cart [ref="stickyBar"]');
  if (!bar) return;

  let api;
  let previousOffset = '';
  let pendingFrame = 0;
  let chatOpen = false;

  function updatePosition() {
    pendingFrame = 0;
    if (!api) return;

    const lift = mobile.matches && !chatOpen && bar.dataset.stuck === 'true';
    const offset = lift
      ? `${Math.ceil(bar.offsetHeight + 12)}px`
      : '0px';
    if (offset === previousOffset) return;

    document.documentElement.style.setProperty('--azikx-tidio-cart-offset', offset);
    previousOffset = offset;
  }

  function scheduleUpdate() {
    if (!pendingFrame) pendingFrame = requestAnimationFrame(updatePosition);
  }

  function onReady() {
    if (api) return;
    const readyApi = window.tidioChatApi;
    if (typeof readyApi?.adjustStyles !== 'function') return;
    api = readyApi;
    api.adjustStyles(
      '@media only screen and (max-width: 749px) { #tidio { bottom: var(--azikx-tidio-cart-offset, 0px) !important; } }'
    );

    api.on('beforeOpen', () => {
      chatOpen = true;
      scheduleUpdate();
    });
    api.on('close', () => {
      chatOpen = false;
      scheduleUpdate();
    });

    new MutationObserver(scheduleUpdate).observe(bar, {
      attributes: true,
      attributeFilter: ['data-stuck'],
    });
    new ResizeObserver(scheduleUpdate).observe(bar);
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.visualViewport?.addEventListener('resize', scheduleUpdate, { passive: true });
    scheduleUpdate();
  }

  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', onReady);
  } else {
    document.addEventListener('tidioChat-ready', onReady, { once: true });
  }
})();
